import { useMutation } from "@tanstack/react-query";
import * as api from "./api";

export function useGenerateHtml() {
  return useMutation({ mutationFn: api.generateHtml });
}

export function useRefineHtml() {
  return useMutation({ mutationFn: api.refineHtml });
}

export function useRenderImage() {
  return useMutation({ mutationFn: api.renderImage });
}
